module.exports = __webpack_public_path__ + "public/SiteIcons/replyArrow.svg?1be3aadd";